import './BlogDetail.scss';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import blogData from '../../data/blog-articles.json';
import BlogContentRenderer from '../../templates/BlogContentRenderer/BlogContentRenderer';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function BlogDetail() {
  const { slug } = useParams();
  const post = blogData.find((item) => item.slug === slug);

  if (!post) return <p>Post not found</p>;

  return (
    <div className="page-layout">
      <Helmet>
        <title>{post.title} - Sony Chen</title>
        <meta name="description" content="Explore Sony Chen’s blog entries and design thoughts." />
      </Helmet>

      <Header />
      <main className="page-layout-main">
        <section className="page-layout-main__section">
          <div className="page-layout-main__section-wrapper">
            <div className="blog-detail">
              <div className="blog-detail__text-container">
                <h1 className="blog-detail__title">{post.title}</h1>
                <p className="blog-detail__date">{post.published}</p>
              </div>

              <img
                className="blog-detail__cover-image"
                src={post.coverImage}
                alt={post.title}
              />

              <div className="blog-detail__content">
                {post.sections.map((section, index) => (
                  <BlogContentRenderer key={index} section={section} />
                ))}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default BlogDetail;